export enum ChartStatusEnum {
  PreAdmitted = 1,
  Admitted = 2,
  Discharged = 3,
  Observation = 4,
  OnHold = 5,
  NTFC = 7,
  Hospitalized = 8
}

export const ChartStatusOptions = [
{ id: 1, label: 'Pre-Admitted', canBePreAdmitted: false },
{ id: 2, label: 'Admitted', canBePreAdmitted: false },
{ id: 3, label: 'Discharged', canBePreAdmitted: true },
{ id: 4, label: 'Observation', canBePreAdmitted: false },
{ id: 5, label: 'On Hold', canBePreAdmitted: false },
{ id: 7, label: 'NTFC', canBePreAdmitted: true },
{ id: 8, label: 'Hospitalized', canBePreAdmitted: false }
];
